import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import DiscountIcon from "./DiscountIcon";
import axios from "axios";
import { prefixUrl } from "../../../Utils/utilsData";
import { toast } from "react-toastify";
import { SetDiscountContext } from "../../pages/Pages";

export default function DiscountCode() {
    const discountContext = useContext(SetDiscountContext);
	const [discountInput, setDiscountInput] = useState(discountContext.code ? discountContext.code : "");
	const [strokeValue, setStrokeValue] = useState("");

	function discountChangeHandler(e) {
		const newValue = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
		setDiscountInput(newValue);
		if (newValue.length > 0) {
			setStrokeValue("pending");
		} else {
			setStrokeValue("");
		}
	}

    useEffect(() => {
        setStrokeValue(discountContext.code ? "done" : "")
    }, [])

	function discountCheck() {
		if (strokeValue === "done" || discountContext.code) {
			return toast.error("کد تخفیف از قبل اعمال شده است");
		}
		if (discountInput.length === 0) {
			return toast.error("لطفا کد تخفیف را وارد کنید");
		}
		axios
			.get(
				`${prefixUrl()}/cart/discountCodeDetail.php?discountCode=${discountInput}`
			)
			.then((response) => {
				if (response.data.status) {
					const result = response.data.output;
					console.log(result);
					if (result.discountType === "percent") {
						discountContext.setCode(result.discountCode);
						discountContext.setType(result.discountType);
						discountContext.setValue({
							percent: result.discountPercent,
							maxPrice: result.discountMaxPrice,
						});
					} else {
                        discountContext.setCode(result.discountCode)
						discountContext.setType(result.discountType);
						discountContext.setValue(result.discountPrice);
					}
					toast.success("کد تخفیف با موفقیت اعمال شد");
					setStrokeValue("done");
					/*
                        discountCode: "2136561"
                        discountMaxPrice: 1000000
                        discountPercent: 10
                        discountPrice: 0
                        discountType: "percent"
                    */
					/*
                        discountCode: "4036159"
                        discountMaxPrice: 0
                        discountPercent: 0
                        discountPrice: 500000
                        discountType: "price"
                    */
				} else {
					toast.error(response.data.output);
				}
			});
	}

	return (
		<main className="discount-main">
			<input
				type="text"
				onChange={discountChangeHandler}
				value={discountInput}
				disabled={(strokeValue === "done" || discountContext.code) ? true : false}
				placeholder="کد تخفیف شما"
			/>
			<div onClick={discountCheck} className="icon-holder">
				<DiscountIcon className={`stroke ${strokeValue}`} />
			</div>
		</main>
	);
}
